/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

/**
 * Cuisine preference options
 */
export enum CuisineOption {
  ITALIAN = "italian",
  CHINESE = "chinese",
  INDIAN = "indian",
  MEXICAN = "mexican",
  MIDDLE_EASTERN = "middleEastern",
  PAN_ASIAN = "panAsian",
}
